import "./SiteIcon.css";

function getContrastColor(hexColor?:string) {
    const darkColor = "#3a3a3aff";
    const lightColor="#ffffffff";
    //if no #, return 000
    if (!hexColor || !hexColor.includes("#")) return "#000"; // default
    const c = hexColor.substring(1); // strip #
    const rgb = parseInt(c, 16); 
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    const luma = 0.299*r + 0.587*g + 0.114*b; // relative luminance

    return luma > 186 ? darkColor : lightColor;
}

export default function SiteIcon(props:{name:string,url:string,icon?:string,color?:string}){
    return (
    <div className="siteicon" style={props.color?{"backgroundColor":props.color}:{}} onClick={()=>{window.location.href=props.url}}>
        {props.icon ? <img src={props.icon} alt={props.name}/> : <></>}
        <span style={{"color":getContrastColor(props.color)}}>{props.name}</span>
    </div>)
}